import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

import css from "./Schedule.module.css";
import { UserContext } from "../../Context/UserContext";
import { Head } from "../../Utils/Head";
import { updateUserFirebase } from "../../Utils/firebaseUser";

export const Schedule = () => {
  const { userData, setUserData } = useContext(UserContext);
  const navigate = useNavigate();
  const [listValue, setListValue] = useState(new Array(7).fill(""));
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const weekFromToday = [
    dayjs(),
    dayjs().add(1, "day"),
    dayjs().add(2, "day"),
    dayjs().add(3, "day"),
    dayjs().add(4, "day"),
    dayjs().add(5, "day"),
    dayjs().add(6, "day"),
  ];

  useEffect(() => {
    if (userData) {
      weekFromToday.forEach((d, i) => {
        if (userData.diary[d.format("YYMMDD")]) {
          listValue[i] = userData.diary[d.format("YYMMDD")];
          setListValue([...listValue]);
        }
      });
    }
  }, [userData]);

  function getCurrentDayClass(day) {
    return day.format("DD-MM-YY") === dayjs().format("DD-MM-YY")
      ? css.currentDay
      : "";
  }

  function handleTimeByDay(day) {
    const dayPor = dayjs(day).format("ddd");
    switch (dayPor) {
      case "Sun":
        return "Dom";
      case "Mon":
        return "Seg";
      case "Tue":
        return "Ter";
      case "Wed":
        return "Qua";
      case "Thu":
        return "Qui";
      case "Fri":
        return "Sex";
      case "Sat":
        return "Sáb";
      default:
        return;
    }
  }

  function handleMood(m) {
    switch (m) {
      case "1":
        return <i className={`material-icons ${css.moodIcon}`}>mood_bad</i>;
      case "2":
        return (
          <i className={`material-icons ${css.moodIcon}`}>
            sentiment_very_dissatisfied
          </i>
        );
      case "3":
        return (
          <i className={`material-icons ${css.moodIcon}`}>
            sentiment_satisfied
          </i>
        );
      case "4":
        return (
          <i className={`material-icons ${css.moodIcon}`}>
            sentiment_satisfied_alt
          </i>
        );
      case "5":
        return (
          <i className={`material-icons ${css.moodIcon}`}>
            sentiment_very_satisfied
          </i>
        );
      default:
        return;
    }
  }

  function handleDeleteAct(a) {
    let updatedList = [...userData.diary[a.date]];
    updatedList = updatedList.filter((e) => e.id !== a.id);
    userData.diary[a.date] = [...updatedList];

    for (let index = 0; index < listValue.length; index++) {
      if (weekFromToday[index].format("YYMMDD") === a.date) {
        listValue[index] = [...updatedList];
        setListValue(listValue);
      }
    }

    setListValue(listValue);
    setUserData(userData);
    updateUserFirebase(userData);
  }

  return (
    // <div className="containerContent">
    <div className={css.container}>
      <Head title="Schedule" description="Schedule - Mairini" />
      <div>
        {/* <button className="orangeButton" onClick={() => navigate("/newact")}>
          Nova Ação
        </button> */}
        <button className="greenButton" onClick={() => navigate("/diary")}>
          Ver Diário completo
        </button>
      </div>

      <div className={css.month}>
        <span className={css.cell_title}>
          {handleTimeByDay(dayjs())}

          <span className={`${css.dayNumber} ${getCurrentDayClass(dayjs())}`}>
            {dayjs().format("DD")}
          </span>
        </span>
        <span className={css.cell_title}>
          {handleTimeByDay(dayjs().add(1, "day"))}{" "}
          <span
            className={`${css.dayNumber} ${getCurrentDayClass(
              dayjs().add(1, "day")
            )}`}
          >
            {dayjs().add(1, "day").format("DD")}
          </span>
        </span>
        <span className={css.cell_title}>
          {handleTimeByDay(dayjs().add(2, "day"))}{" "}
          <span
            className={`${css.dayNumber} ${getCurrentDayClass(
              dayjs().add(2, "day")
            )}`}
          >
            {dayjs().add(2, "day").format("DD")}
          </span>
        </span>
        <span className={css.cell_title}>
          {handleTimeByDay(dayjs().add(3, "day"))}{" "}
          <span
            className={`${css.dayNumber} ${getCurrentDayClass(
              dayjs().add(3, "day")
            )}`}
          >
            {dayjs().add(3, "day").format("DD")}
          </span>
        </span>
        <span className={css.cell_title}>
          {handleTimeByDay(dayjs().add(4, "day"))}{" "}
          <span
            className={`${css.dayNumber} ${getCurrentDayClass(
              dayjs().add(4, "day")
            )}`}
          >
            {dayjs().add(4, "day").format("DD")}
          </span>
        </span>
        <span className={css.cell_title}>
          {handleTimeByDay(dayjs().add(5, "day"))}{" "}
          <span
            className={`${css.dayNumber} ${getCurrentDayClass(
              dayjs().add(5, "day")
            )}`}
          >
            {dayjs().add(5, "day").format("DD")}
          </span>
        </span>
        <span className={css.cell_title}>
          {handleTimeByDay(dayjs().add(6, "day"))}{" "}
          <span
            className={`${css.dayNumber} ${getCurrentDayClass(
              dayjs().add(6, "day")
            )}`}
          >
            {dayjs().add(6, "day").format("DD")}
          </span>
        </span>
        {listValue.map((act, idx) => (
          <span className={`${css.day_name}`} key={idx}>
            {act[0] &&
              act.map((a, i) =>
                a.done ? (
                  <div key={i} className={css.eventActDone}>
                    <p>{a.act}</p>
                    <p>
                      {a.value} {handleMood(a.mood)}
                    </p>
                  </div>
                ) : (
                  <div
                    key={i}
                    className={css.eventAct}
                    // onClick={() => setShowDeleteModal(a)}
                  >
                    <p>{a.act}</p>
                    <p>{a.value}</p>
                  </div>
                )
              )}
          </span>
        ))}
      </div>

      {showDeleteModal && (
        <div className={css.modalContainer}>
          <div className={css.modal}>
            <header className={css.modalHeader}>
              <span
                onClick={() => setShowDeleteModal(false)}
                className={`material-icons ${css.materialIcon} ${css.materialButton}`}
              >
                close
              </span>
            </header>
            <div className={css.modalBody}>
              <h4>Deletar ação: {showDeleteModal.act}</h4>

              <footer className={css.modalFooter}>
                <button
                  className="defaultButton"
                  onClick={() => {
                    setShowDeleteModal(false);
                  }}
                >
                  Cancelar
                </button>
                <button
                  className="deleteButton"
                  onClick={() => {
                    handleDeleteAct(showDeleteModal);
                    setShowDeleteModal(false);
                  }}
                >
                  Deletar
                </button>
              </footer>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
